import {Dimmer, Dropdown, Form, Loader, Popup} from "semantic-ui-react";
import ReferralStatusOptions from "./ReferralStatusOptions";
import OralReferIn from "../../styles/images/oral-in.png";
import OralReferOut from "../../styles/images/oral-out.png";
import OrthoRefOut from "../../styles/images/ortho-out.png";
import OrthoRefIn from "../../styles/images/ortho-in.png";
import React, {useEffect, useState} from "react";
import {PracticeList} from "../../model/practice";
import {practiceType} from "../../constants";
import {DropdownProps} from "semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown";

interface IProps {
    production: any;
    practiceListAll: PracticeList[];
    onChangeFilter: (props: { practice: string[]; type: string }) => void;
    getMonthlyData: (type: string, ignore?: boolean) => void;
    oralSurgeryStatus: any;
    defaultPractices: any;
}
function createContextFromEvent(e: React.MouseEvent) {
    const left = e.clientX
    const top = e.clientY
    const right = left + 1
    const bottom = top + 1
    return {
        getBoundingClientRect: () => ({
            left,
            top,
            right,
            bottom,
            height: 0,
            width: 0,
        }),
    }
}


export default function ReferralsFilters(props: IProps) {
    const contextRef = React.useRef(null as any);
    const [statusTitle, SetStatusTitle] = useState("");
    const [reportType, SetReportType] = useState("");
    const [openStatusDropdown, setOpenStatusDropdown] = useState(false);
    const [open, setOpen] = useState(false);
    const [filter, setFilter] = useState({practice: [props.defaultPractices?.[0] ?? 'All'], type: "All"});

    const openDropdown = (e: React.MouseEvent, title: string, type: string) => {
        e.preventDefault()

        contextRef.current = createContextFromEvent(e)
        props.getMonthlyData(type, true)
        SetReportType(type);
        SetStatusTitle(title);
        setOpenStatusDropdown(true);
    };

    useEffect(() => {
        if(props.defaultPractices?.[0])
            setFilter({...filter, practice: props.defaultPractices?.[0]});
    }, [props.defaultPractices]);

    const totals = {
        orthoRefIn: props.production.orthoRefIn,
        orthoRefOut: props.production.orthoRefOut,
        oralRefIn: props.production.oralReferIn,
        oralRefOut: props.production.oralRefOut,
    };

    const onChange = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
        let value = data.value as string[] ?? [];
        if(data.multiple){
            if (!value || value.length < 1 || value[value.length - 1] === "All") {
                value = ["All"];
            } else if (value.includes("All")) {
                value = value.filter((item: string) => item !== "All");
            }
        }
        const params = {...filter, [data.name]: value}
        setFilter(params);
        !open && props.onChangeFilter(params);
    };

    const practiceOptions = [
        {
            key: "All",
            value: "All",
            text: "All",
        },
        ...(props.practiceListAll ?? []).map((practice: PracticeList) => {
            return {
                key: practice.id,
                value: practice.practice,
                text: practice.practice,
            };
        }),
    ];

    return (
        <div>
            <Form className="float-right">
                <Form.Group>
                    <Form.Field>
              <span className="cursorPointer d-flex mr20"
                    onClick={(e) => openDropdown(e, "Ortho Referrals (Out)", "orthoRefOut")}>
                <img alt="referout" src={OrthoRefOut}/>
                <b className="label-referral">{props.production.orthoRefOut ?? 0}</b>
              </span>
                    </Form.Field>
                    <Form.Field>
              <span className="cursorPointer d-flex mr20"
                    onClick={(e) => openDropdown(e, "Ortho Referrals (In)", "orthoRefIn")}>
                <img alt="referin" src={OrthoRefIn}/>
                  <b className="label-referral">{props.production.orthoRefIn ?? 0}</b>
              </span>
                    </Form.Field>
                    <Form.Field>
              <span
                  className="cursorPointer d-flex mr20"
                  onClick={(e) => openDropdown(e,"Oral Surgery Referrals (Out)", "oralRefOut")}
              >
                <img alt="referout" src={OralReferOut}/>
                  <b className="label-referral">{props.production.oralRefOut ?? 0}</b>
              </span>
                    </Form.Field>
                    <Form.Field>
              <span className="cursorPointer d-flex mr20"
                    onClick={(e) => openDropdown(e,"Oral Surgery Referrals (In)", "oralRefIn")}>
                <img alt="referin" src={OralReferIn}/>
                  <b className="label-referral">{props.production.oralRefIn ?? 0}</b>
              </span>
                    </Form.Field>
                    <Form.Field>
                        <Dropdown
                            search={true}
                            className="mr10 mb15"
                            name="practice"
                            placeholder="Practice"
                            selection={true}
                            multiple={true}
                            options={practiceOptions}
                            onChange={onChange}
                            value={filter.practice}
                            onBlur={() => props.onChangeFilter(filter)}
                            onOpen={() => setOpen(true)}
                            onClose={() => setOpen(false)}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Dropdown
                            search
                            className="mr10 mb15"
                            name="type"
                            placeholder="Practice Type"
                            selection
                            options={practiceType}
                            value={filter.type}
                            onChange={onChange}
                            onClose={() => setOpen(false)}
                            onBlur={() => props.onChangeFilter(filter)}
                        />
                    </Form.Field>
                </Form.Group>
            </Form>


            {contextRef?.current && <Popup position='bottom center' onClose={() => setOpenStatusDropdown(false)} open={openStatusDropdown} context={contextRef}>
                {openStatusDropdown && (
                    <ReferralStatusOptions
                        statusTitle={statusTitle}
                        getMonthlyData={props.getMonthlyData}
                        handleStatusMenuClick={() => setOpenStatusDropdown(!openStatusDropdown)}
                        reportData={props.production.reportData}
                        reportType={reportType}
                        statuses={props.oralSurgeryStatus}
                        totals={totals}
                    />
                )}
            </Popup>}
        </div>
    );
}
